/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { getUserAuth } from './api'
import { getComapnyByKey, goToLink } from './projectData'
import { FullPageLoader } from '../component/helper'



export function CustomerLoginWithoutRedemness() {

    const { companyname, key, memberid, mobile } = useParams();
    console.log(companyname, key, memberid, mobile, "companyname, key, memberid, mobile")
    const [loading, setLoading] = useState(true)
    const [response, setResponse] = useState('')
    const navigate = useNavigate();

    useEffect(() => {
        // Check if any parameter is missing
        // const requiredParams = { companyname, key, memberid, mobile };

        if (!companyname || !key || !memberid || !mobile) {
            // const missing = Object.entries(requiredParams).filter(([_, value]) => !value).map(([key]) => key);
            // setMissingFields(missing);
            return;
        }
        const projectData = getComapnyByKey(companyname);
        const data = {
            secret_key: key,
            project_key: 'TEST-PROJECT-PCLGTZNS-P1',
            memberid,
            mobile,

        };

        // Make the API call
        const fetchData = async () => {
            try {
                const responseToken = await getUserAuth(data)

                if (Number(responseToken.code) === 1) {
                    setLoading(false)
                    localStorage.setItem('cuslogin', JSON.stringify(responseToken?.data))
                    localStorage.setItem('pkey', projectData?.pkey)
                    localStorage.setItem('company', companyname)
                    localStorage.setItem('dtype', 'kyc')
                    goToLink(navigate, '/customer/dashboard', [])
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                    //navigate('/customer/dashboard')
                } else {
                    setTimeout(() => {
                        setLoading(false)
                    }, 500);
                    setResponse(responseToken.message || 'Login Token Error');
                }

            } catch (error) {
                console.error('API error:', error);
            }
        };

        fetchData();
    }, [key, memberid, mobile, navigate, companyname]);



    return (
        <div className="d-flex flex-column align-items-center vh-100  p-2 mt-6" style={{ backgroundColor: "#fff" }}>
            {loading ? <FullPageLoader></FullPageLoader> : <>
                <div className='d-flex justify-content-center'>
                    <img src={`/media/auth/error.png`} className="" alt="" style={{ width: '150px', height: '150px' }} />
                </div>

                <div style={{ border: '1px solid #dadada' }} className="card card-flush w-100">
                    <div style={{ background: '#FBF6F7', minHeight: '39px' }} className="card-header p-3">
                        <div style={{ color: '#FF4141' }} className="card-title">Authentication error !</div>
                    </div>
                    <div className="card-body">
                        <div style={{ color: '#000' }} className="fs-6 w-100">
                            {response ? response : null}

                        </div>
                        <div>

                        </div>
                    </div>
                </div>
            </>}
        </div>
    )
}
